// import React, { useEffect, useState } from "react";
// import {
//   TextField,
//   Typography,
//   Button,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   IconButton,
//   styled,
//   Box,
// } from "@mui/material";
// import { Delete } from "@mui/icons-material";
// import useAuth from "../../../hooks/useAuth";
// import { useNavigate, useParams } from "react-router-dom";
// import { jwtDecode } from "jwt-decode";
// import * as Yup from 'yup';

// const validationSchema = Yup.object({
//   // Validation for the free-text fields
//   workDescription: Yup.string()
//     .required('This field is required.')
//     .min(3, 'Please provide a more detailed description.'),

//   hoursDescription: Yup.string()
//     .required('This field is required.')
//     .min(3, 'Please provide more details about the hours spent.'),

//   // Validation for dynamic rows (Item and Hours per Month)
//   rows: Yup.array().of(
//     Yup.object({
//       item: Yup.string()
//         .required('Item is required.'),

//       hours: Yup.number()
//         .required('Hours per month is required.')
//         .positive('Hours should be a positive number.')
//         .integer('Hours should be an integer.')
//         .max(744, 'The number of hours cannot exceed the maximum in a month (744 hours).'), // Assuming 31 days max
//     })
//   )
//   .min(1, 'At least one task needs to be added.')
//   .max(10, 'You cannot add more than 10 tasks.'),  // Limiting number of rows to 10

//   // Validation for the comments section
//   comments: Yup.string()

//     .max(500, 'Comments cannot be more than 500 characters.')
// });
// const Step4 = ({ currentStep, onPrev }) => {
//   const { users } = useAuth();
//   // const userId = useParams();
//   const [isJwtUser, setIsJwtUser] = useState(false);

//   const { id: param } = useParams();
//   const navigate = useNavigate();

//   const [rows, setRows] = useState([
//     { id: 1, item: "", hours: "" },
//     { id: 2, item: "", hours: "" },
//     { id: 3, item: "", hours: "" },
//   ]); // Initial row
//   const [comments, setComments] = useState("");
//   const [error, setError] = useState(false);

//   const [employeeId, setEmployeeId] = useState(null);
//   useEffect(() => {
//     if (users?.role === "manager") {
//       if (param.includes(".")) {
//         try {
//           const decoded = jwtDecode(param); // Decode JWT token
//           setEmployeeId(decoded?.user_id);
//           setIsJwtUser(true); // Set employeeId in state
//           console.log(decoded?.user_id); // Extract user ID from token
//         } catch (error) {
//           console.error("Invalid token:", error);
//           setEmployeeId(null);
//         }
//       } else {
//         setEmployeeId(param);
//         setIsJwtUser(false); // If not a token, use the param as employee ID
//       }
//     } else {
//       setEmployeeId(users?.user_id); // Use logged-in user ID for non-managers
//     }
//   }, [users, param]);
//   console.log(employeeId);
//   // Add a new row if less than 10 items exist
//   const addRow = () => {
//     if (rows.length < 10) {
//       setRows([...rows, { id: rows.length + 1, item: "", hours: "" }]);
//     }
//   };

//   // Handle input changes for table fields
//   const handleChange = (id, field, value) => {
//     const updatedRows = rows.map((row) =>
//       row.id === id ? { ...row, [field]: value } : row
//     );
//     setRows(updatedRows);
//     // Revalidate after each change

//   };

//   // Remove row by id
//   const removeRow = (id) => {
//     const updatedRows = rows.filter((row) => row.id !== id);
//     setRows(updatedRows);
//   };

//   // Calculate total hours
//   const totalHours = rows.reduce(
//     (sum, row) => sum + (Number(row.hours) || 0),
//     0
//   );

//   // Handle form submission

//   const handleNext = () => {
//     console.log("hiii")

//     //   setError(true);
//       if (isJwtUser) {
//         navigate(`/view`, {
//           state: {
//             isJwtUser: true,
//             userId: employeeId, // Pass the employeeId for JWT-based users
//           },
//         }); // Redirect to a separate page for JWT-based users
//       } else {
//         if (users?.role === "manager") {
//           // navigate(`/manager-view/${userId?.id}`);

//           navigate(`/manager-view/${employeeId}`);
//         } else {
//           navigate("/view");
//         } // Redirect managers to manager view
//       }

//   };

//   return (
//     <>
//       <FormMiddleBoxWrap
//         sx={{
//           paddingTop: "30px",
//           paddingBottom: "0px",
//           marginBottom: "0",
//           boxShadow: "0",
//           position: "relative",
//           zIndex: "1",
//         }}
//       >
//         <RowWrap>
//           <Col12Wrap>
//             <CustomHead>
//               What work are you doing that you know or suspect is outside the
//               scope of your role?
//             </CustomHead>
//             <FormLabelWrap
//               sx={{
//                 fontSize: "14px",
//                 color: "#7C7C7C",
//                 letterSpacing: "0.3px",
//                 marginBottom: "0px",
//               }}
//             >
//               How many hours per month does this pull you away from the work
//               you're being expected to perform?
//             </FormLabelWrap>
//           </Col12Wrap>
//         </RowWrap>
//       </FormMiddleBoxWrap>
//       <FormMiddleBoxWrap sx={{ paddingTop: "30px", paddingBottom: "50px" }}>
//         <RowWrap>
//           <Col12Wrap>
//             <FormGroupWrap sx={{ marginBottom: "0" }}>
//               <Box
//                 sx={{
//                   display: "flex",
//                   flexWrap: "wrap",
//                   alignItems: "end",
//                   columnGap: "10px",
//                   marginBottom: "10px",
//                 }}
//               >
//                 <Box sx={{ width: "calc(50% - 5px)" }}>
//                   <FormLabelWrap sx={{ fontSize: "16px", marginBottom: "0" }}>
//                     Item
//                   </FormLabelWrap>

//                 </Box>
//                 <Box sx={{ width: "calc(50% - 5px)" }}>
//                   <FormLabelWrap sx={{ fontSize: "16px", marginBottom: "0" }}>
//                     Hours per Month
//                   </FormLabelWrap>
//                 </Box>
//               </Box>
//               {rows.map((row, index) => (
//                 <Box
//                   key={index}
//                   sx={{
//                     display: "flex",
//                     flexWrap: "wrap",
//                     alignItems: "flex-start",
//                     columnGap: "10px",
//                     marginBottom: "10px",
//                     position: "relative",
//                   }}
//                 >
//                   <Box sx={{ width: "calc(50% - 5px)" }}>
//                     <CustomTextField
//                       sx={{
//                         "& .MuiInputBase-input": {
//                           padding: "10px 20px",
//                         },
//                       }}
//                       variant="outlined"
//                       value={row.item}
//                       onChange={(e) =>
//                         handleChange(row.id, "item", e.target.value)
//                       }
//                       placeholder="Describe task"
//                     />
//                   </Box>
//                   <Box sx={{ width: "calc(50% - 5px)" }}>
//                     <CustomTextField
//                       sx={{
//                         "& .MuiInputBase-input": {
//                           padding: "10px 20px",
//                         },
//                       }}
//                       variant="outlined"
//                       value={row.hours}
//                       onChange={(e) =>
//                         handleChange(row.id, "hours", e.target.value)
//                       }
//                       placeholder="Hours"
//                     />
//                   </Box>
//                   <Box sx={{ width: "20px" }}>
//                     <CustomBtn
//                       type="button"
//                       onClick={() => removeRow(row.id)}
//                       variant="outlined"
//                       sx={{
//                         fontSize: "5px",
//                         fontWeight: "600",
//                         color: "#E75B5B",
//                         borderColor: "#F0F0F0",
//                         borderRadius: "7px",
//                         background: "#F0F0F0",
//                         // padding: "5px",
//                         position: "absolute",
//                         top: "9px",
//                         right: "-30px",
//                         width: "25px",
//                         height: "25px",
//                         minWidth: "0",
//                         padding: "6px",
//                         // Adjust padding for a compact button
//                         "& svg": {
//                           margin: "0", // Remove extra margin around the icon
//                         },
//                       }}
//                     >
//                       <svg
//                         width="16"
//                         height="16"
//                         viewBox="0 0 16 16"
//                         fill="none"
//                         xmlns="http://www.w3.org/2000/svg"
//                       >
//                         <path
//                           d="M1 1L15 15M15 1L1 15"
//                           stroke="#E75B5B"
//                           strokeWidth="2"
//                           strokeLinecap="round"
//                         />
//                       </svg>
//                     </CustomBtn>
//                   </Box>
//                 </Box>
//               ))}
//               <Box
//                 sx={{
//                   display: "flex",
//                   flexWrap: "wrap",
//                   alignItems: "center",
//                   columnGap: "10px",
//                   marginBottom: "10px",
//                 }}
//               >
//                 <Box width={{ width: "calc(50% - 5px)" }}>
//                   <CustomBtn
//                     type="button"
//                     onClick={addRow}
//                     disabled={rows.length >= 10}
//                     variant="outlined"
//                     sx={{
//                       fontSize: "14px",
//                       fontWeight: "600",
//                       color: "#1085AB",
//                       borderColor: "#F0F0F0",
//                       borderRadius: "7px",
//                       background: "#F0F0F0",
//                       maxWidth: "90px",
//                       padding: "10px 10px",
//                       "& svg": {
//                         marginRight: "8px",
//                       },
//                     }}
//                   >
//                     <svg
//                       width="16"
//                       height="16"
//                       viewBox="0 0 16 16"
//                       fill="none"
//                       xmlns="http://www.w3.org/2000/svg"
//                     >
//                       <path
//                         d="M8.10767 1L8.10767 15"
//                         stroke="#F28021"
//                         strokeWidth="2"
//                         strokeLinecap="round"
//                       />
//                       <path
//                         d="M1 8.18335L15 8.18335"
//                         stroke="#F28021"
//                         strokeWidth="2"
//                         strokeLinecap="round"
//                       />
//                     </svg>{" "}
//                     Add
//                   </CustomBtn>
//                 </Box>
//                 <Box sx={{ width: "calc(50% - 5px)" }}>
//                   <FormLabelWrap
//                     sx={{
//                       fontSize: "16px",
//                       fontWeight: "500",
//                       textAlign: "center",
//                       marginBottom: "0",
//                     }}
//                   >
//                     {totalHours} hours/mo
//                   </FormLabelWrap>
//                 </Box>
//               </Box>
//             </FormGroupWrap>
//           </Col12Wrap>
//         </RowWrap>
//       </FormMiddleBoxWrap>
//       <FormLastBoxWrap sx={{ paddingTop: "30px", paddingBottom: "50px" }}>
//         <RowWrap>
//           <Col12Wrap>
//             <FormGroupWrap>
//               <FormLabelWrap
//                 sx={{
//                   fontSize: "16px",
//                   color: "#7C7C7C",
//                   letterSpacing: "0.3px",
//                   marginBottom: "10px",
//                 }}
//               >
//                 Share any thoughts on this topic that would provide context or
//                 needed information.
//               </FormLabelWrap>
//               <CustomTextField
//                 variant="outlined"
//                 value={comments}
//                 onChange={(e) => setComments(e.target.value)}
//                 multiline
//                 rows={3}
//                 placeholder="Share your thoughts"
//               />
//             </FormGroupWrap>
//           </Col12Wrap>
//         </RowWrap>
//       </FormLastBoxWrap>
//       <FormBtnBoxWrap>
//            <RowWrap>
//              <Col12Wrap sx={{ textAlign: "center" }}>
//               <CustomBtn
//             type="button"
//             variant="outlined"
//             sx={{
//               marginRight: "10px", // Add spacing between buttons
//               "& svg": { marginRight: "10px" },
//             }}
//             onClick={onPrev} // Call the onPrev function on click
//           >
//             <svg
//               width="15"
//               height="16"
//               viewBox="0 0 15 16"
//               fill="none"
//               xmlns="http://www.w3.org/2000/svg"
//             >
//               <path
//                 d="M14 7C14.5523 7 15 7.44772 15 8C15 8.55228 14.5523 9 14 9L14 7ZM0.292893 8.70711C-0.0976311 8.31658 -0.097631 7.68342 0.292893 7.29289L6.65685 0.928932C7.04738 0.538407 7.68054 0.538407 8.07107 0.928932C8.46159 1.31946 8.46159 1.95262 8.07107 2.34315L2.41421 8L8.07107 13.6569C8.46159 14.0474 8.46159 14.6805 8.07107 15.0711C7.68054 15.4616 7.04738 15.4616 6.65685 15.0711L0.292893 8.70711ZM14 9L1 9L1 7L14 7L14 9Z"
//                 fill="white"
//               />
//             </svg>
//             Previous
//           </CustomBtn>
//               <CustomBtn
//               type="submit"
//               variant="outlined"
//               onClick={handleNext}
//             >
//               Submit
//             </CustomBtn>
//             </Col12Wrap>
//           </RowWrap>
//         </FormBtnBoxWrap>

//       {/* <div style={{ width: "80%", margin: "auto", padding: "20px" }}>
//         <Typography variant="h5" gutterBottom>
//           Work Outside Your Role
//         </Typography>
//         <TableContainer component={Paper}>
//           <Table>
//             <TableHead>
//               <TableRow>
//                 <TableCell>Item</TableCell>
//                 <TableCell>Hours per Month</TableCell>
//                 <TableCell>Action</TableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {rows.map((row) => (
//                 <TableRow key={row.id}>
//                   <TableCell>
//                     <TextField
//                       fullWidth
//                       value={row.item}
//                       onChange={(e) =>
//                         handleChange(row.id, "item", e.target.value)
//                       }
//                       placeholder="Describe task"
//                     />
//                   </TableCell>
//                   <TableCell>
//                     <TextField
//                       type="number"
//                       fullWidth
//                       value={row.hours}
//                       onChange={(e) =>
//                         handleChange(row.id, "hours", e.target.value)
//                       }
//                       placeholder="Hours"
//                     />
//                   </TableCell>
//                   <TableCell>
//                     <IconButton onClick={() => removeRow(row.id)} color="error">
//                       <Delete />
//                     </IconButton>
//                   </TableCell>
//                 </TableRow>
//               ))}
//             </TableBody>
//           </Table>
//         </TableContainer>

//         <Button
//           onClick={addRow}
//           variant="contained"
//           color="primary"
//           style={{ marginTop: "10px" }}
//           disabled={rows.length >= 10}
//         >
//           Add Another Item
//         </Button>

//         <Typography
//           variant="h6"
//           style={{ marginTop: "20px", fontWeight: "bold" }}
//         >
//           How many hours per month does this pull you away from the work you’re
//           being expected to perform?
//           <span style={{ fontSize: "20px", fontWeight: "bold", color: "red" }}>
//             {" "}
//             {totalHours} hours/mo
//           </span>
//         </Typography>

//         <TextField
//           label="Share any thoughts on this topic that would provide context or needed information."
//           multiline
//           rows={4}
//           fullWidth
//           required
//           error={error}
//           helperText={error ? "This field is required" : ""}
//           value={comments}
//           onChange={(e) => setComments(e.target.value)}
//           style={{ marginTop: "10px" }}
//         />

//         <div
//           style={{
//             marginTop: "20px",
//             display: "flex",
//             justifyContent: "space-between",
//           }}
//         >
//           <Button onClick={onPrev} variant="outlined">
//             Previous
//           </Button>
//           <Button onClick={handleNext} variant="contained" color="secondary">
//             Next
//           </Button>
//         </div>
//       </div> */}
//     </>
//   );
// };

// export default Step4;

// const RowWrap = styled(Box)(() => ({
//   display: "flex",
//   flexWrap: "wrap",
//   marginLeft: "-15px",
//   marginRight: "-15px",
// }));
// const Col12Wrap = styled(Box)(() => ({
//   flex: "0 0 auto",
//   width: "100%",
//   maxWidth: "100%",
//   paddingLeft: "15px",
//   paddingRight: "15px",
// }));
// const FormMiddleBoxWrap = styled(Box)(() => ({
//   padding: "50px 150px",
//   background: "#ffffff",
//   maxWidth: "1030px",
//   marginLeft: "auto",
//   marginRight: "auto",
//   marginBottom: "16px",
//   boxShadow: "0 0 5px 0 rgba(0, 0, 0, 0.05)",
//   "@media (max-width: 1199px)": {
//     maxWidth: "100%",
//     paddingLeft: "100px",
//     paddingRight: "100px",
//   },
//   "@media (max-width: 991px)": {
//     paddingLeft: "50px",
//     paddingRight: "50px",
//   },
//   "@media (max-width: 575px)": {
//     paddingLeft: "15px",
//     paddingRight: "15px",
//   },
// }));
// const CustomHead = styled(Typography)(() => ({
//   fontSize: "26px",
//   fontWeight: "600",
//   lineHeight: "1.445",
//   color: "#1085AB",
//   "@media (max-width: 575px)": {
//     fontSize: "22px",
//   },
// }));
// const FormLabelWrap = styled(Typography)(() => ({
//   fontSize: "20px",
//   fontWeight: "500",
//   lineHeight: "1.445",
//   color: "#000000",
//   marginBottom: "10px",
// }));
// const FormGroupWrap = styled(Box)(() => ({
//   marginBottom: "30px",
//   position: "relative",
// }));
// const CustomTextField = styled(TextField)(({ error = false }) => ({
//   width: "100%",
//   border: error ? "1px solid rgb(210, 33, 33)" : "1px solid #DADADA",
//   borderRadius: "7px",
//   "& .MuiInputBase-input": {
//     fontSize: "16px",
//     fontWeight: "300",
//     lineHeight: "1",
//     color: "#2C2C2E",
//     padding: "14px 20px",
//   },
//   "& fieldset": {
//     border: "none",
//   },
// }));
// const CustomBtn = styled(Button)(() => ({
//   width: "100%",
//   fontSize: "22px",
//   fontWeight: "400",
//   lineHeight: "1",
//   color: "#ffffff",
//   textTransform: "capitalize",
//   background: "#F28021",
//   borderColor: "#F28021",
//   borderRadius: "10px",
//   // padding: "19px 20px",
//   // maxWidth: "300px",
//   maxWidth: "150px",
//   padding: "10px 15px",
//   boxShadow: "none !important",
// }));
// const FormLastBoxWrap = styled(Box)(() => ({
//   padding: "50px 150px",
//   background: "#ffffff",
//   maxWidth: "1030px",
//   borderRadius: "0px 0px 7px 7px",
//   marginLeft: "auto",
//   marginRight: "auto",
//   marginBottom: "16px",
//   boxShadow: "0 0 5px 0 rgba(0, 0, 0, 0.05)",
//   "@media (max-width: 1199px)": {
//     maxWidth: "100%",
//     paddingLeft: "100px",
//     paddingRight: "100px",
//   },
//   "@media (max-width: 991px)": {
//     paddingLeft: "50px",
//     paddingRight: "50px",
//   },
//   "@media (max-width: 575px)": {
//     paddingLeft: "15px",
//     paddingRight: "15px",
//   },
// }));
// const FormBtnBoxWrap = styled(Box)(() => ({
//     maxWidth: "1030px",
//     marginLeft: "auto",
//     marginRight: "auto",
//     marginTop: "30px",
//     "@media (max-width: 1199px)": {
//       maxWidth: "100%",
//     },
//   }));import React, { useEffect } from "react";

import React, { useEffect, useState } from "react";
import {
  TextField,
  Typography,
  Button,
  Box,
  styled,
  FormHelperText,
} from "@mui/material";
import useAuth from "../../../hooks/useAuth";
import { Link, useNavigate, useParams } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import {
  useAddWorkdataMutation,
  useGetWorkdataQuery,
} from "../../../services/roleReviewService";

const ErrorText = styled("div")`
  color: red;
  font-size: 12px;
  margin-top: 4px;
  margin-left: 10px;
`;

const validationSchema = Yup.object({
  rows: Yup.array()
    .of(
      Yup.object({
        hours: Yup.number()
          .transform((value) => (isNaN(value) ? undefined : value))
          .positive("Hours should be a positive number.")
          .integer("Hours should be an integer.")
          .max(744, "Hours cannot exceed 744")
         
      })
    )
    
    .max(10, "You cannot add more than 10 tasks.")
    .test("totalHours", "Total hours cannot exceed 744", (rows) => {
      if (!rows) return true;
      const total = rows.reduce(
        (sum, row) => sum + (Number(row.hours) || 0),
        0
      );
      return total <= 744;
    }),

  
});

const Step4 = ({ onPrev }) => {
  const { users } = useAuth();
  const { id: param } = useParams();
  const navigate = useNavigate();
  const [isJwtUser, setIsJwtUser] = useState(false);
  const [employeeId, setEmployeeId] = useState(null);

  const {
    control,
    handleSubmit,
    formState: { errors },
    watch,
    setValue,
    getValues,
    reset,
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      rows: [
        { item: "", hours: "" },
        { item: "", hours: "" },
        { item: "", hours: "" },
      ],
      comments: "",
    },
    mode: "onChange",
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "rows",
  });

  const handleAddRow = () => {
    if (fields.length < 10) {
      append({ item: "", hours: "" });
    }
  };

  const handleRemoveRow = (index) => {
    remove(index);
  };
  const [addWorkdata] = useAddWorkdataMutation();
  const {
    data: workDataResponse,
    isLoading,
    refetch:work_data,
  } = useGetWorkdataQuery(employeeId, {
    skip: !employeeId, 
    enabled:!!employeeId// Skip the query if employeeId is not yet available
  });

  // useEffect(() => {
  //   reset({
  //     rows: [
  //       { item: "", hours: "" },
  //       { item: "", hours: "" },
  //       { item: "", hours: "" },
  //     ],
  //     comments: "",
  //   });
  // }, [reset]);

  useEffect(() => {
    if (users?.role === "manager") {
      if (param.includes(".")) {
        try {
          const decoded = jwtDecode(param);
          setEmployeeId(decoded?.user_id);
          setIsJwtUser(true);
        } catch (error) {
          console.error("Invalid token:", error);
          setEmployeeId(null);
        }
      } else {
        setEmployeeId(param);
        setIsJwtUser(false);
      }
    } else {
      setEmployeeId(users?.user_id);
    }
  }, [users, param]);
 

  useEffect(() => {
    
    if (workDataResponse) {
      
      console.log("workDataResponse", workDataResponse?.data?.comments);
      const apiComments = workDataResponse.data.comments;
      const transformedRows = workDataResponse?.data?.work_data.map(
        (item, index) => ({
          item: item.work_description,
          hours: item.hours_per_month,
          id: index + 1,
        })
      );
      console.log(apiComments);
      reset({ rows: transformedRows, comments: apiComments });

    //   setValue("comments", apiComments);
    //   reset({ rows: transformedRows });  // Reset the form with transformed rows
    }
  }, [workDataResponse, setValue, reset, work_data]);

  const watchedRows = watch("rows");

  //   const totalHours = useMemo(() => {
  //     return watchedRows.reduce((sum, row) => {
  //       const hours = parseFloat(row.hours);
  //       return sum + (isNaN(hours) ? 0 : hours);
  //     }, 0);
  //   }, [watchedRows]);
  const totalHours = watchedRows.reduce(
    (sum, area) => sum + (parseFloat(area.hours) || 0),
    0
  );
  useEffect(() => {
    if (employeeId) {
      work_data(); // Trigger refetch when employeeId changes
    }
  }, [employeeId,work_data ]);
  const onSubmit = async (data) => {
    console.log("Form Data (Formatted for API):", data);
    
    const apiData = {
      user_id: employeeId,
      work_data: data.rows.map((row) => ({
        work_description: row.item,
        hours_per_month: row.hours,
        rows: JSON.stringify(data.rows),
      })),
      comments: data.comments,
    };

    try {
      const response = await addWorkdata(apiData).unwrap();
      console.log("API Response:", response);
      if (isJwtUser) {
        navigate(`/view`, {
          state: {
            isJwtUser: true,
            userId: employeeId, // Pass the employeeId for JWT-based users
          },
        }); // Redirect to a separate page for JWT-based users
      } else {
        if (users?.role === "manager") {
          // navigate(`/manager-view/${userId?.id}`);

          navigate(`/manager-view/${employeeId}`);
        } else {
          navigate("/view");
        } // Redirect managers to manager view
      }
    } catch (error) {
      console.error("API Error:", error);
    }
  };
  const saveDataToBackend = async (data) => {
    console.log("Form Data (Formatted for API):", data);

    const apiData = {
      user_id: employeeId,
      work_data: data.rows.map((row) => ({
        work_description: row.item,
        hours_per_month: row.hours,
        rows: JSON.stringify(data.rows),
      })),
      comments: data.comments,
    };

    try {
      await addWorkdata(apiData).unwrap();
      console.log("Data saved successfully to backend");
    } catch (error) {
      console.error("Error saving data:", error);
    }
};

// Handle previous button click
  const handlePrevious = async (formData) => {
      try {
        // Get the latest form data
        await saveDataToBackend(formData); // Save the data
        onPrev(); // Navigate to the previous step
      } catch (error) {
        console.error("Error saving data before going back:", error);
      }
  };


  if (isLoading) {
    return <Typography>Loading...</Typography>;
  }

  //   if (error) {
  //     return <Typography color="error">Error fetching data: {error.message}</Typography>;
  //   }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <FormMiddleBoxWrap
        sx={{
          paddingTop: "30px",
          paddingBottom: "0px",
          marginBottom: "0",
          boxShadow: "0",
          position: "relative",
          zIndex: "1",
        }}
      >
        <RowWrap>
          <Col12Wrap>
            <CustomHead>
              What work are you doing that you know or suspect is outside the
              scope of your role?
            </CustomHead>
            <FormLabelWrap
              sx={{
                fontSize: "20px",
                color: "#7C7C7C",
                letterSpacing: "0.3px",
                marginBottom: "0px",
              }}
            >
              How many hours per month does this pull you away from the work
              you're being expected to perform?
            </FormLabelWrap>
            <FormLabelWrap
                    sx={{
                      fontSize: "20px",
                      color: "#7C7C7C",
                      letterSpacing: "0.3px",
                      marginBottom: "10px",
                    }}
                  >
                    If needed, there is a short video to guide you.{" "}
                    <Link
                      to="https://youtu.be/vMelUwt0j1g"
                      target="_blank"
                      rel="noopener noreferrer"
                      sx={{ color: "#1976d2", textDecoration: "underline", fontWeight: "bold" }}
                    >
                      Click here to watch video
                    </Link>
                  </FormLabelWrap>
          </Col12Wrap>
        </RowWrap>
      </FormMiddleBoxWrap>

      <FormMiddleBoxWrap sx={{ paddingTop: "30px", paddingBottom: "50px" }}>
        <RowWrap>
          <Col12Wrap>
            <FormGroupWrap sx={{ marginBottom: "0" }}>
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  alignItems: "end",
                  columnGap: "10px",
                  marginBottom: "10px",
                }}
              >
                <Box sx={{ width: "calc(50% - 5px)" }}>
                  <FormLabelWrap sx={{ fontSize: "16px", marginBottom: "0" }}>
                    Item
                  </FormLabelWrap>
                </Box>
                <Box sx={{ width: "calc(50% - 5px)" }}>
                  <FormLabelWrap sx={{ fontSize: "16px", marginBottom: "0" }}>
                    Hours per Month
                  </FormLabelWrap>
                </Box>
              </Box>
              {fields.map((row, index) => (
                <Box
                  key={row.id}
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    alignItems: "flex-start",
                    columnGap: "10px",
                    marginBottom: "10px",
                    position: "relative",
                  }}
                >
                  <Box sx={{ width: "calc(50% - 5px)" }}>
                    <>
                      <Controller
                        name={`rows.${index}.item`}
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <>
                            <CustomTextField
                              sx={{
                                "& .MuiInputBase-input": {
                                  padding: "10px 20px",
                                },
                              }}
                              variant="outlined"
                              placeholder="Describe task"
                              {...field}
                              error={!!errors.rows?.[index]?.item}
                            />
                            {errors.rows?.[index]?.item && (
                              <FormHelperText error>
                                {errors.rows[index].item.message}
                              </FormHelperText>
                            )}
                          </>
                        )}
                      />
                    </>
                  </Box>
                  <Box sx={{ width: "calc(50% - 5px)" }}>
                    <>
                      <Controller
                        name={`rows.${index}.hours`}
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <>
                            <CustomTextField
                              sx={{
                                "& .MuiInputBase-input": {
                                  padding: "10px 20px",
                                },
                              }}
                              type="number"
                              variant="outlined"
                              placeholder="Hours"
                              {...field}
                              error={!!errors.rows?.[index]?.hours}
                            />
                            {errors.rows?.[index]?.hours && (
                              <ErrorText>
                                {errors.rows[index].hours.message}
                              </ErrorText>
                            )}
                          </>
                        )}
                      />
                    </>
                  </Box>
                  <Box sx={{ width: "20px" }}>
                    <CustomBtn
                      type="button"
                      onClick={() => handleRemoveRow(index)}
                      variant="outlined"
                      sx={{
                        fontSize: "5px",
                        fontWeight: "600",
                        color: "#E75B5B",
                        borderColor: "#F0F0F0",
                        borderRadius: "7px",
                        background: "#F0F0F0",
                        position: "absolute",
                        top: "9px",
                        right: "-30px",
                        width: "25px",
                        height: "25px",
                        minWidth: "0",
                        padding: "6px",
                        "& svg": {
                          margin: "0",
                        },
                      }}
                    >
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1 1L15 15M15 1L1 15"
                          stroke="#E75B5B"
                          strokeWidth="2"
                          strokeLinecap="round"
                        />
                      </svg>
                    </CustomBtn>
                  </Box>
                </Box>
              ))}
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  alignItems: "center",
                  columnGap: "10px",
                  marginBottom: "10px",
                }}
              >
                <Box width={{ width: "calc(50% - 5px)" }}>
                  <CustomBtn
                    type="button"
                    onClick={handleAddRow}
                    disabled={fields.length >= 10}
                    variant="outlined"
                    sx={{
                      fontSize: "14px",
                      fontWeight: "600",
                      color: "#1085AB",
                      borderColor: "#F0F0F0",
                      borderRadius: "7px",
                      background: "#F0F0F0",
                      maxWidth: "90px",
                      padding: "10px 10px",
                      "& svg": {
                        marginRight: "8px",
                      },
                    }}
                  >
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8.10767 1L8.10767 15"
                        stroke="#F28021"
                        strokeWidth="2"
                        strokeLinecap="round"
                      />
                      <path
                        d="M1 8.18335L15 8.18335"
                        stroke="#F28021"
                        strokeWidth="2"
                        strokeLinecap="round"
                      />
                    </svg>{" "}
                    Add
                  </CustomBtn>
                </Box>
                <Box sx={{ width: "calc(50% - 5px)" }}>
                  <FormLabelWrap
                    sx={{
                      fontSize: "16px",
                      fontWeight: "500",
                      textAlign: "center",
                      marginBottom: "0",
                    }}
                  >
                    {totalHours} hours/mo
                  </FormLabelWrap>
                  {totalHours > 744 && (
                    <ErrorText>Total hours/month cannot exceed 744!</ErrorText>
                  )}
                </Box>
                {errors.rows && errors.rows.message && (
                  <FormHelperText error style={{ textAlign: "center" }}>
                    {errors.rows.message}
                  </FormHelperText>
                )}
              </Box>
            </FormGroupWrap>
          </Col12Wrap>
        </RowWrap>
      </FormMiddleBoxWrap>

      <FormLastBoxWrap sx={{ paddingTop: "30px", paddingBottom: "50px" }}>
        <RowWrap>
          <Col12Wrap>
            <FormGroupWrap>
              <FormLabelWrap
                sx={{
                  fontSize: "20px",
                  color: "#7C7C7C",
                  letterSpacing: "0.3px",
                  marginBottom: "10px",
                }}
              >
                Share any thoughts on this topic that would provide context or
                needed information.
              </FormLabelWrap>
            
              <Controller
  name="comments"
  control={control}
  render={({ field }) => (
    <>
       {/* Debugging */}
      
      <CustomTextField
        variant="outlined"
        multiline
        rows={3}
        placeholder="Share your thoughts"
        {...field}
       
      />
    </>
  )}
/>
              {/* <Controller
                name="comments"
                control={control}
                
                render={({ field }) => (
                  <>
                    {console.log(field)}
                    {errors.comments && (
                      <FormHelperText error>
                        {errors.comments.message}
                      </FormHelperText>
                    )}
                    <CustomTextField
                      variant="outlined"
                      multiline
                      rows={3}
                      placeholder="Share your thoughts"
                      {...field}
                      error={!!errors.comments}
                    />
                  </>
                )}
              /> */}
            </FormGroupWrap>
          </Col12Wrap>
        </RowWrap>
      </FormLastBoxWrap>

      <FormBtnBoxWrap>
        <RowWrap>
          <Col12Wrap sx={{ textAlign: "center" }}>
            <CustomBtn
              type="button"
              variant="outlined"
              sx={{
                marginRight: "10px",
                "& svg": { marginRight: "10px" },
              }}
              onClick={() => handlePrevious(getValues())} 
            >
              <svg
                width="15"
                height="16"
                viewBox="0 0 15 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14 7C14.5523 7 15 7.44772 15 8C15 8.55228 14.5523 9 14 9L14 7ZM0.292893 8.70711C-0.0976311 8.31658 -0.097631 7.68342 0.292893 7.29289L6.65685 0.928932C7.04738 0.538407 7.68054 0.538407 8.07107 0.928932C8.46159 1.31946 8.46159 1.95262 8.07107 2.34315L2.41421 8L8.07107 13.6569C8.46159 14.0474 8.46159 14.6805 8.07107 15.0711C7.68054 15.4616 7.04738 15.4616 6.65685 15.0711L0.292893 8.70711ZM14 9L1 9L1 7L14 7L14 9Z"
                  fill="white"
                />
              </svg>
              Previous
            </CustomBtn>
            <CustomBtn
              type="submit"
              variant="outlined"
              onClick={handleSubmit(onSubmit)}
            >
              Submit
            </CustomBtn>
          </Col12Wrap>
        </RowWrap>
      </FormBtnBoxWrap>
    </form>
  );
};

export default Step4;

const RowWrap = styled(Box)(() => ({
  display: "flex",
  flexWrap: "wrap",
  marginLeft: "-15px",
  marginRight: "-15px",
}));
const Col12Wrap = styled(Box)(() => ({
  flex: "0 0 auto",
  width: "100%",
  maxWidth: "100%",
  paddingLeft: "15px",
  paddingRight: "15px",
}));
const FormMiddleBoxWrap = styled(Box)(() => ({
  padding: "50px 150px",
  background: "#ffffff",
  maxWidth: "1030px",
  marginLeft: "auto",
  marginRight: "auto",
  marginBottom: "16px",
  boxShadow: "0 0 5px 0 rgba(0, 0, 0, 0.05)",
  "@media (max-width: 1199px)": {
    maxWidth: "100%",
    paddingLeft: "100px",
    paddingRight: "100px",
  },
  "@media (max-width: 991px)": {
    paddingLeft: "50px",
    paddingRight: "50px",
  },
  "@media (max-width: 575px)": {
    paddingLeft: "15px",
    paddingRight: "15px",
  },
}));
const CustomHead = styled(Typography)(() => ({
  fontSize: "26px",
  fontWeight: "600",
  lineHeight: "1.445",
  color: "#1085AB",
  "@media (max-width: 575px)": {
    fontSize: "22px",
  },
}));
const FormLabelWrap = styled(Typography)(() => ({
  fontSize: "20px",
  fontWeight: "500",
  lineHeight: "1.445",
  color: "#000000",
  marginBottom: "10px",
}));
const FormGroupWrap = styled(Box)(() => ({
  marginBottom: "30px",
  position: "relative",
}));
const CustomTextField = styled(TextField)(({ error }) => ({
  width: "100%",
  border: error ? "1px solid rgb(210, 33, 33)" : "1px solid #DADADA",
  borderRadius: "7px",
  "& .MuiInputBase-input": {
    fontSize: "16px",
    fontWeight: "300",
    lineHeight: "1",
    color: "#2C2C2E",
    padding: "14px 20px",
  },
  "& fieldset": {
    border: "none",
  },
}));
const CustomBtn = styled(Button)(() => ({
  width: "100%",
  fontSize: "22px",
  fontWeight: "400",
  lineHeight: "1",
  color: "#ffffff",
  textTransform: "capitalize",
  background: "#F28021",
  borderColor: "#F28021",
  borderRadius: "10px",
  maxWidth: "150px",
  padding: "10px 15px",
  boxShadow: "none !important",
}));
const FormLastBoxWrap = styled(Box)(() => ({
  padding: "50px 150px",
  background: "#ffffff",
  maxWidth: "1030px",
  borderRadius: "0px 0px 7px 7px",
  marginLeft: "auto",
  marginRight: "auto",
  marginBottom: "16px",
  boxShadow: "0 0 5px 0 rgba(0, 0, 0, 0.05)",
  "@media (max-width: 1199px)": {
    maxWidth: "100%",
    paddingLeft: "100px",
    paddingRight: "100px",
  },
  "@media (max-width: 991px)": {
    paddingLeft: "50px",
    paddingRight: "50px",
  },
  "@media (max-width: 575px)": {
    paddingLeft: "15px",
    paddingRight: "15px",
  },
}));
const FormBtnBoxWrap = styled(Box)(() => ({
  maxWidth: "1030px",
  marginLeft: "auto",
  marginRight: "auto",
  marginTop: "30px",
  "@media (max-width: 1199px)": {
    maxWidth: "100%",
  },
}));
// import {
//     TextField,
//     Typography,
//     Button,
//     Box,
//     styled,
//     FormHelperText,
//   } from "@mui/material";
//   import useAuth from "../../../hooks/useAuth";
//   import { useNavigate, useParams } from "react-router-dom";
//   import { jwtDecode } from "jwt-decode";
//   import { useForm, Controller, useFieldArray } from "react-hook-form";
//   import { yupResolver } from '@hookform/resolvers/yup';
//   import * as Yup from 'yup';
//   import { useEffect, useMemo, useState } from "react";
//   const ErrorText = styled("div")`
//   color: red;
//   font-size: 12px;
//   margin-top: 4px;
//   margin-left: 10px;
// `;
//   const validationSchema = Yup.object({
//     rows: Yup.array().of(
//       Yup.object({
//         item: Yup.string()
//           .required('Item is required.'),

//         hours: Yup.number()
//           .transform((value) => (isNaN(value) ? undefined : value))
//           .required('Hours per month is required.')
//           .positive('Hours should be a positive number.')
//           .integer('Hours should be an integer.')
//           .max(744, 'Hours cannot exceed 744'),
//       })
//     )
//       .min(1, 'At least one task needs to be added.')
//       .max(10, 'You cannot add more than 10 tasks.')
//       .test(
//         'totalHours',
//         'Total hours cannot exceed 744',
//         (rows) => {
//           if (!rows) return true; // Allow empty arrays during initial render
//           const total = rows.reduce((sum, row) => sum + (Number(row.hours) || 0), 0);
//           return total <= 744;
//         }
//       ),

//     comments: Yup.string()
//       .max(500, 'Comments cannot be more than 500 characters.')
//   });

//   const Step4 = ({ onPrev }) => {
//     const { users } = useAuth();
//     const { id: param } = useParams();
//     const navigate = useNavigate();
//     const [isJwtUser, setIsJwtUser] = useState(false);
//     const [employeeId, setEmployeeId] = useState(null);

//     const { control, handleSubmit, formState: { errors }, watch, setValue, reset } = useForm({
//       resolver: yupResolver(validationSchema),
//       defaultValues: {
//         rows: [
//           { item: "", hours: "" },
//           { item: "", hours: "" },
//           { item: "", hours: "" },
//         ],
//         comments: ""
//       },
//       mode: "onChange" // Validate on every change
//     });

//     const { fields, append, remove } = useFieldArray({
//       control,
//       name: "rows"
//     });

//     const handleAddRow = () => {
//       if (fields.length < 10) {
//         append({ item: "", hours: "" });
//       }
//     };

//     const handleRemoveRow = (index) => {
//       remove(index);
//     };

//     useEffect(() => {
//       reset({
//         rows: [
//           { item: "", hours: "" },
//           { item: "", hours: "" },
//           { item: "", hours: "" },
//         ],
//         comments: ""
//       });
//     }, [reset]);

//     useEffect(() => {
//       if (users?.role === "manager") {
//         if (param.includes(".")) {
//           try {
//             const decoded = jwtDecode(param);
//             setEmployeeId(decoded?.user_id);
//             setIsJwtUser(true);
//           } catch (error) {
//             console.error("Invalid token:", error);
//             setEmployeeId(null);
//           }
//         } else {
//           setEmployeeId(param);
//           setIsJwtUser(false);
//         }
//       } else {
//         setEmployeeId(users?.user_id);
//       }
//     }, [users, param]);

//     const watchedRows = watch("rows"); // Watch all rows

//     // const totalHours = useMemo(() => {
//     //   return watchedRows.reduce((sum, row) => {
//     //     const hours = parseFloat(row.hours);
//     //     return sum + (isNaN(hours) ? 0 : hours); // Use parseFloat and check for NaN
//     //   }, 0);
//     // }, [watchedRows]);
//     const totalHours = watchedRows.reduce(
//         (sum, area) => sum + (parseFloat(area.hours) || 0),
//         0
//       );

//     const onSubmit = (data) => {
//       console.log("Form Data:", data);

//       if (isJwtUser) {
//         navigate(`/view`, {
//           state: {
//             isJwtUser: true,
//             userId: employeeId,
//           },
//         });
//       } else {
//         if (users?.role === "manager") {
//           navigate(`/manager-view/${employeeId}`);
//         } else {
//           navigate("/view");
//         }
//       }
//     };

//     return (
//       <>
//         <FormMiddleBoxWrap
//           sx={{
//             paddingTop: "30px",
//             paddingBottom: "0px",
//             marginBottom: "0",
//             boxShadow: "0",
//             position: "relative",
//             zIndex: "1",
//           }}
//         >
//           <RowWrap>
//             <Col12Wrap>
//               <CustomHead>
//                 What work are you doing that you know or suspect is outside the
//                 scope of your role?
//               </CustomHead>
//               <FormLabelWrap
//                 sx={{
//                   fontSize: "14px",
//                   color: "#7C7C7C",
//                   letterSpacing: "0.3px",
//                   marginBottom: "0px",
//                 }}
//               >
//                 How many hours per month does this pull you away from the work
//                 you're being expected to perform?
//               </FormLabelWrap>
//             </Col12Wrap>
//           </RowWrap>
//         </FormMiddleBoxWrap>

//         <FormMiddleBoxWrap sx={{ paddingTop: "30px", paddingBottom: "50px" }}>
//           <RowWrap>
//             <Col12Wrap>
//               <FormGroupWrap sx={{ marginBottom: "0" }}>
//                 <Box
//                   sx={{
//                     display: "flex",
//                     flexWrap: "wrap",
//                     alignItems: "end",
//                     columnGap: "10px",
//                     marginBottom: "10px",
//                   }}
//                 >
//                   <Box sx={{ width: "calc(50% - 5px)" }}>
//                     <FormLabelWrap sx={{ fontSize: "16px", marginBottom: "0" }}>
//                       Item
//                     </FormLabelWrap>
//                   </Box>
//                   <Box sx={{ width: "calc(50% - 5px)" }}>
//                     <FormLabelWrap sx={{ fontSize: "16px", marginBottom: "0" }}>
//                       Hours per Month
//                     </FormLabelWrap>
//                   </Box>
//                 </Box>
//                 {fields.map((row, index) => (
//                   <Box
//                     key={row.id}
//                     sx={{
//                       display: "flex",
//                       flexWrap: "wrap",
//                       alignItems: "flex-start",
//                       columnGap: "10px",
//                       marginBottom: "10px",
//                       position: "relative",
//                     }}
//                   >
//                     <Box sx={{ width: "calc(50% - 5px)" }}>

//                       <Controller
//                         name={`rows.${index}.item`}
//                         control={control}
//                         defaultValue=""
//                         render={({ field }) => (
//                           <>

//                             <CustomTextField
//                               sx={{
//                                 "& .MuiInputBase-input": {
//                                   padding: "10px 20px",
//                                 },
//                               }}
//                               variant="outlined"
//                               placeholder="Describe task"
//                               {...field}
//                               error={!!errors.rows?.[index]?.item}

//                             />
//                             {errors.rows?.[index]?.item && (
//                               <FormHelperText error>
//                                 {errors.rows[index].item.message}
//                               </FormHelperText>
//                             )}
//                           </>
//                         )}
//                       />
//                     </Box>
//                     <Box sx={{ width: "calc(50% - 5px)" }}>
//                       <Controller
//                         name={`rows.${index}.hours`}
//                         control={control}
//                         defaultValue=""
//                         render={({ field }) => (
//                           <>

//                             <CustomTextField
//                               sx={{
//                                 "& .MuiInputBase-input": {
//                                   padding: "10px 20px",
//                                 },
//                               }}
//                               type="number"
//                               variant="outlined"
//                               placeholder="Hours"
//                               {...field}
//                               error={!!errors.rows?.[index]?.hours}
//                             />
//                             {errors.rows?.[index]?.hours && (
//                               <FormHelperText error>
//                                 {errors.rows[index].hours.message}
//                               </FormHelperText>
//                             )}
//                           </>
//                         )}
//                       />
//                     </Box>
//                     <Box sx={{ width: "20px" }}>
//                       <CustomBtn
//                         type="button"
//                         onClick={() => handleRemoveRow(index)}
//                         variant="outlined"
//                         sx={{
//                           fontSize: "5px",
//                           fontWeight: "600",
//                           color: "#E75B5B",
//                           borderColor: "#F0F0F0",
//                           borderRadius: "7px",
//                           background: "#F0F0F0",
//                           position: "absolute",
//                           top: "9px",
//                           right: "-30px",
//                           width: "25px",
//                           height: "25px",
//                           minWidth: "0",
//                           padding: "6px",
//                           "& svg": {
//                             margin: "0",
//                           },
//                         }}
//                       >
//                         <svg
//                           width="16"
//                           height="16"
//                           viewBox="0 0 16 16"
//                           fill="none"
//                           xmlns="http://www.w3.org/2000/svg"
//                         >
//                           <path
//                             d="M1 1L15 15M15 1L1 15"
//                             stroke="#E75B5B"
//                             strokeWidth="2"
//                             strokeLinecap="round"
//                           />
//                         </svg>
//                       </CustomBtn>
//                     </Box>
//                   </Box>
//                 ))}
//                 <Box
//                   sx={{
//                     display: "flex",
//                     flexWrap: "wrap",
//                     alignItems: "center",
//                     columnGap: "10px",
//                     marginBottom: "10px",
//                   }}
//                 >
//                   <Box width={{ width: "calc(50% - 5px)" }}>
//                     <CustomBtn
//                       type="button"
//                       onClick={handleAddRow}
//                       disabled={fields.length >= 10}
//                       variant="outlined"
//                       sx={{
//                         fontSize: "14px",
//                         fontWeight: "600",
//                         color: "#1085AB",
//                         borderColor: "#F0F0F0",
//                         borderRadius: "7px",
//                         background: "#F0F0F0",
//                         maxWidth: "90px",
//                         padding: "10px 10px",
//                         "& svg": {
//                           marginRight: "8px",
//                         },
//                       }}
//                     >
//                       <svg
//                         width="16"
//                         height="16"
//                         viewBox="0 0 16 16"
//                         fill="none"
//                         xmlns="http://www.w3.org/2000/svg"
//                       >
//                         <path
//                           d="M8.10767 1L8.10767 15"
//                           stroke="#F28021"
//                           strokeWidth="2"
//                           strokeLinecap="round"
//                         />
//                         <path
//                           d="M1 8.18335L15 8.18335"
//                           stroke="#F28021"
//                           strokeWidth="2"
//                           strokeLinecap="round"
//                         />
//                       </svg>{" "}
//                       Add
//                     </CustomBtn>
//                   </Box>
//                   <Box sx={{ width: "calc(50% - 5px)" }}>
//                     <FormLabelWrap
//                       sx={{
//                         fontSize: "16px",
//                         fontWeight: "500",
//                         textAlign: "center",
//                         marginBottom: "0",
//                       }}
//                     >
//                       {totalHours} hours/mo
//                     </FormLabelWrap>
//                     {totalHours > 744 && (
//   <ErrorText>Total hours/month cannot exceed 744!</ErrorText>
// )}
//                   </Box>
//                   {errors.rows && errors.rows.message && (
//                     <FormHelperText error style={{ textAlign: "center" }}>
//                       {errors.rows.message}
//                     </FormHelperText>
//                   )}
//                 </Box>
//               </FormGroupWrap>
//             </Col12Wrap>
//           </RowWrap>
//         </FormMiddleBoxWrap>

//         <FormLastBoxWrap sx={{ paddingTop: "30px", paddingBottom: "50px" }}>
//           <RowWrap>
//             <Col12Wrap>
//               <FormGroupWrap>
//                 <FormLabelWrap
//                   sx={{
//                     fontSize: "16px",
//                     color: "#7C7C7C",
//                     letterSpacing: "0.3px",
//                     marginBottom: "10px",
//                   }}
//                 >
//                   Share any thoughts on this topic that would provide context or
//                   needed information.
//                 </FormLabelWrap>
//                 <Controller
//                   name="comments"
//                   control={control}
//                   defaultValue=""
//                   render={({ field }) => (
//                     <>
//                       {errors.comments && (
//                         <FormHelperText error>
//                           {errors.comments.message}
//                         </FormHelperText>
//                       )}
//                       <CustomTextField
//                         variant="outlined"
//                         multiline
//                         rows={3}
//                         placeholder="Share your thoughts"
//                         {...field}
//                         error={!!errors.comments}
//                       />
//                     </>
//                   )}
//                 />
//               </FormGroupWrap>
//             </Col12Wrap>
//           </RowWrap>
//         </FormLastBoxWrap>

//         <FormBtnBoxWrap>
//           <RowWrap>
//             <Col12Wrap sx={{ textAlign: "center" }}>
//               <CustomBtn
//                 type="button"
//                 variant="outlined"
//                 sx={{
//                   marginRight: "10px",
//                   "& svg": { marginRight: "10px" },
//                 }}
//                 onClick={onPrev}
//               >
//                 <svg
//                   width="15"
//                   height="16"
//                   viewBox="0 0 15 16"
//                   fill="none"
//                   xmlns="http://www.w3.org/2000/svg"
//                 >
//                   <path
//                     d="M14 7C14.5523 7 15 7.44772 15 8C15 8.55228 14.5523 9 14 9L14 7ZM0.292893 8.70711C-0.0976311 8.31658 -0.097631 7.68342 0.292893 7.29289L6.65685 0.928932C7.04738 0.538407 7.68054 0.538407 8.07107 0.928932C8.46159 1.31946 8.46159 1.95262 8.07107 2.34315L2.41421 8L8.07107 13.6569C8.46159 14.0474 8.46159 14.6805 8.07107 15.0711C7.68054 15.4616 7.04738 15.4616 6.65685 15.0711L0.292893 8.70711ZM14 9L1 9L1 7L14 7L14 9Z"
//                     fill="white"
//                   />
//                 </svg>
//                 Previous
//               </CustomBtn>
//               <CustomBtn
//                 type="submit"
//                 variant="outlined"
//                 onClick={handleSubmit(onSubmit)}
//               >
//                 Submit
//               </CustomBtn>
//             </Col12Wrap>
//           </RowWrap>
//         </FormBtnBoxWrap>
//       </>
//     );
//   };

//   export default Step4;

//   const RowWrap = styled(Box)(() => ({
//     display: "flex",
//     flexWrap: "wrap",
//     marginLeft: "-15px",
//     marginRight: "-15px",
//   }));
//   const Col12Wrap = styled(Box)(() => ({
//     flex: "0 0 auto",
//     width: "100%",
//     maxWidth: "100%",
//     paddingLeft: "15px",
//     paddingRight: "15px",
//   }));
//   const FormMiddleBoxWrap = styled(Box)(() => ({
//     padding: "50px 150px",
//     background: "#ffffff",
//     maxWidth: "1030px",
//     marginLeft: "auto",
//     marginRight: "auto",
//     marginBottom: "16px",
//     boxShadow: "0 0 5px 0 rgba(0, 0, 0, 0.05)",
//     "@media (max-width: 1199px)": {
//       maxWidth: "100%",
//       paddingLeft: "100px",
//       paddingRight: "100px",
//     },
//     "@media (max-width: 991px)": {
//       paddingLeft: "50px",
//       paddingRight: "50px",
//     },
//     "@media (max-width: 575px)": {
//       paddingLeft: "15px",
//       paddingRight: "15px",
//     },
//   }));
//   const CustomHead = styled(Typography)(() => ({
//     fontSize: "26px",
//     fontWeight: "600",
//     lineHeight: "1.445",
//     color: "#1085AB",
//     "@media (max-width: 575px)": {
//       fontSize: "22px",
//     },
//   }));
//   const FormLabelWrap = styled(Typography)(() => ({
//     fontSize: "20px",
//     fontWeight: "500",
//     lineHeight: "1.445",
//     color: "#000000",
//     marginBottom: "10px",
//   }));
//   const FormGroupWrap = styled(Box)(() => ({
//     marginBottom: "30px",
//     position: "relative",
//   }));
//   const CustomTextField = styled(TextField)(({ error }) => ({
//     width: "100%",
//     border: error ? "1px solid rgb(210, 33, 33)" : "1px solid #DADADA",
//     borderRadius: "7px",
//     "& .MuiInputBase-input": {
//       fontSize: "16px",
//       fontWeight: "300",
//       lineHeight: "1",
//       color: "#2C2C2E",
//       padding: "14px 20px",
//     },
//     "& fieldset": {
//       border: "none",
//     },
//   }));
//   const CustomBtn = styled(Button)(() => ({
//     width: "100%",
//     fontSize: "22px",
//     fontWeight: "400",
//     lineHeight: "1",
//     color: "#ffffff",
//     textTransform: "capitalize",
//     background: "#F28021",
//     borderColor: "#F28021",
//     borderRadius: "10px",
//     maxWidth: "150px",
//     padding: "10px 15px",
//     boxShadow: "none !important",
//   }));
//   const FormLastBoxWrap = styled(Box)(() => ({
//     padding: "50px 150px",
//     background: "#ffffff",
//     maxWidth: "1030px",
//     borderRadius: "0px 0px 7px 7px",
//     marginLeft: "auto",
//     marginRight: "auto",
//     marginBottom: "16px",
//     boxShadow: "0 0 5px 0 rgba(0, 0, 0, 0.05)",
//     "@media (max-width: 1199px)": {
//       maxWidth: "100%",
//       paddingLeft: "100px",
//       paddingRight: "100px",
//     },
//     "@media (max-width: 991px)": {
//       paddingLeft: "50px",
//       paddingRight: "50px",
//     },
//     "@media (max-width: 575px)": {
//       paddingLeft: "15px",
//       paddingRight: "15px",
//     },
//   }));
//   const FormBtnBoxWrap = styled(Box)(() => ({
//     maxWidth: "1030px",
//     marginLeft: "auto",
//     marginRight: "auto",
//     marginTop: "30px",
//     "@media (max-width: 1199px)": {
//       maxWidth: "100%",
//     },
//   }));
